<div class="task-task-client-address-sel">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-lavuro m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-capitalize">
          Seleccione la Dirección deseada
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 task-task-client-address-sel-content">

      <div class="row">
        <div class="col-md-12" *ngFor="let address of addresses">
          <button type="button" class="btn btn-link text-left text-success mx-0 p-1" (click)="selectAddress(address)">
            <i class="material-icons">place</i>
            {{address.address}}
          </button>
        </div>
      </div>

      <div class="row" *ngIf="false">
        <div class="col-12 pt-4">
          <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link d-none d-md-inline"
            (click)="dialog.close(false)"> Volver
          </button>
        </div>
      </div>
    </div>
  </div>
</div>